const NotificationSettingsConstants = {
    DEVICE_GROUP: {
        RM_EMAIL: 'RM_EMAIL',
    },
    TYPE_GROUP: {
        RM_REVIEW: 'RM_REVIEW',
    },
};

export default NotificationSettingsConstants;
